"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const moment = require("moment");
const icons_1 = require("@dialogexe/cw-asset-provider/icons");
const images_1 = require("@dialogexe/cw-asset-provider/images");
require("moment/locale/nn");
require("moment/locale/nb");
const SPACE = `\u00A0`;
const NORMAL = "normal";
const OPEN = "open";
class LandScapeCard extends React.Component {
    constructor(props) {
        super(props);
        this.getMinMaxDate = () => {
            const tickets = this.props.tickets;
            if (tickets.length > 0) {
                const dates = tickets.map(t => moment(t.date).startOf('day').unix());
                const min = Math.min(...dates);
                const max = Math.max(...dates);
                return { min, max };
            }
            return { min: null, max: null };
        };
        this.isSalesNotEnabled = () => {
            const { tickets } = this.props;
            return tickets.every(ticket => ticket.salesEnabled === false);
        };
        this.isSoldOut = () => {
            const { tickets } = this.props;
            return tickets.every(ticket => ticket.count <= 0 && ticket.ticketSaleType === NORMAL);
        };
        this.isOpenArrangement = () => {
            const { tickets } = this.props;
            return tickets.every(ticket => ticket.ticketSaleType === OPEN);
        };
        this.renderTicketStatus = (ticket, link) => {
            const { preferredLanguage } = this.props;
            const buyTicketLable = preferredLanguage === 'nn' ? "Kjøp billettar" : "Kjøp billetter";
            if (this.isSalesNotEnabled()) {
                return (React.createElement("span", null, " Salg ikke \u00E5pnet "));
            }
            if (this.isSoldOut()) {
                return (React.createElement("span", null, " Utsolgt "));
            }
            if (this.isOpenArrangement()) {
                return (React.createElement("span", null, " Gratis arrangement "));
            }
            if (ticket) {
                return (React.createElement("a", { href: ticket.link },
                    buyTicketLable,
                    " "));
            }
            else {
                return (React.createElement("a", { href: `${link}/#tickets` },
                    " ",
                    buyTicketLable,
                    " "));
            }
        };
        const preferredLanguage = props.preferredLanguage ? props.preferredLanguage : 'nb';
        moment.locale(preferredLanguage);
    }
    render() {
        const { image, title, link, tickets, preferredLanguage } = this.props;
        const { min, max } = this.getMinMaxDate();
        const count = tickets.length;
        const ticket = count === 1 ? tickets[0] : null;
        const arrangementsLable = preferredLanguage === 'nn' ? "framsyningar" : "forestillinger";
        const readMore = preferredLanguage === 'nn' ? "Les meir" : "Les mer";
        return (React.createElement("div", { className: "LandscapeCard" },
            React.createElement("div", { className: "landscapeCard-image" },
                React.createElement("a", { href: link },
                    React.createElement("img", { src: image ? image : images_1.landscapeImagePlaceholder })),
                React.createElement("div", { className: "landscapeCard-date" },
                    min && React.createElement("div", { className: `landscapeCard-date ${(min === max && count > 1) ? 'landscapeCard-date-multi-same-day' : 'landscapeCard-date-min'}` },
                        React.createElement("div", null,
                            " ",
                            moment.unix(min).format("DD"),
                            ". "),
                        React.createElement("div", null,
                            " ",
                            moment.unix(min).format("MMM").toLocaleUpperCase(),
                            " ")),
                    min != max &&
                        React.createElement("div", { className: "landscapeCard-date landscapeCard-date-dash" }, "-"),
                    max && min != max &&
                        React.createElement("div", { className: "landscapeCard-date landscapeCard-date-max" },
                            React.createElement("div", null,
                                " ",
                                moment.unix(max).format("DD"),
                                ". "),
                            React.createElement("div", null,
                                " ",
                                moment.unix(max).format("MMM").toLocaleUpperCase(),
                                " ")),
                    (count > 1 || min != max) &&
                        React.createElement("div", { className: "landscapeCard-date landscapeCard-date-count" },
                            React.createElement("p", null, `${count} ${arrangementsLable}`)))),
            title && (React.createElement("div", { className: `landscapeCard-title` },
                React.createElement("a", { href: link }, title))),
            ticket &&
                React.createElement("div", { className: "landscapeCards-time-location" },
                    this.getTime(ticket.date),
                    " ",
                    SPACE,
                    " |  ",
                    SPACE,
                    " ",
                    ticket.location),
            React.createElement("div", { className: "landscapeCard-links" },
                React.createElement("div", null,
                    React.createElement("i", { className: "icon is-small" },
                        React.createElement("img", { src: icons_1.eventTicketIcon, alt: "" })),
                    this.renderTicketStatus(ticket, link)),
                React.createElement("div", null,
                    React.createElement("i", { className: "icon is-small" },
                        React.createElement("img", { src: icons_1.frameCArrowRight, alt: "" })),
                    React.createElement("a", { href: link },
                        " ",
                        readMore,
                        " ")))));
    }
    getTime(date) {
        return moment(date).format('HH:mm');
    }
}
exports.LandScapeCard = LandScapeCard;
exports.default = LandScapeCard;



// WEBPACK FOOTER //
// ./~/@dialogexe/cw-component-landscape-card/LandScapeCard.tsx